import {
  AppPermissionMasterCreateFormState,
  AppPermissionMasterEditFormState,
  AppPermissionMasterRaw,
} from "@/domain/AppPermissionMaster";
import { OrganizationRaw } from "@/domain/Organization";
import { API_CLIENT } from "../config";
import { getAPIConfigs } from "../helpers";

const apiUrlPermissionMasters = "/admin/app_permission_masters";

export const getAdminAppPermissionMasters = async ({
  organizationId,
}: {
  organizationId?: string;
}): Promise<AppPermissionMasterRaw[]> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.get<{ items: AppPermissionMasterRaw[] }>(
    apiUrlPermissionMasters,
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data.items;
};

export const getAdminAppPermissionMasterOrgs = async ({
  appPermissionMasterId,
}: {
  appPermissionMasterId: string;
}): Promise<OrganizationRaw[]> => {
  const response = await API_CLIENT.get(
    `${apiUrlPermissionMasters}/${appPermissionMasterId}/orgs`
  );
  return response.data.items as OrganizationRaw[];
};

export const postAdminCreateAppPermissionMaster = async ({
  appPermissionMasterCreateFormState,
  organizationId,
}: {
  appPermissionMasterCreateFormState: AppPermissionMasterCreateFormState;
  organizationId?: string;
}): Promise<AppPermissionMasterRaw> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.post<{ item: AppPermissionMasterRaw }>(
    apiUrlPermissionMasters,
    {
      ...appPermissionMasterCreateFormState,
    },
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data.item;
};

export const postAdminEditAppPermissionMaster = async ({
  appPermissionMasterId,
  appPermissionMasterEditFormState,
}: {
  appPermissionMasterId: string;
  appPermissionMasterEditFormState: AppPermissionMasterEditFormState;
}): Promise<AppPermissionMasterRaw> => {
  const response = await API_CLIENT.post<{ item: AppPermissionMasterRaw }>(
    `${apiUrlPermissionMasters}/${appPermissionMasterId}`,
    {
      ...appPermissionMasterEditFormState,
    }
  );
  return response.data.item;
};

export const postAdminDisableAppPermissionMaster = async ({
  appPermissionMasterId,
}: {
  appPermissionMasterId: string;
}): Promise<AppPermissionMasterRaw> => {
  const response = await API_CLIENT.post<{ item: AppPermissionMasterRaw }>(
    `${apiUrlPermissionMasters}/${appPermissionMasterId}/delete`
  );
  return response.data.item;
};

export const postAdminEnableAppPermissionMaster = async ({
  appPermissionMasterId,
}: {
  appPermissionMasterId: string;
}): Promise<AppPermissionMasterRaw> => {
  const response = await API_CLIENT.post<{ item: AppPermissionMasterRaw }>(
    `${apiUrlPermissionMasters}/${appPermissionMasterId}/enable`
  );
  return response.data.item;
};

export const postAdminRemoveAppPermissionMaster = async ({
  appPermissionMasterId,
}: {
  appPermissionMasterId: string;
}): Promise<void> => {
  await API_CLIENT.post<{ item: AppPermissionMasterRaw }>(
    `${apiUrlPermissionMasters}/${appPermissionMasterId}/remove`
  );
};
